const AboutDetailPageReducer = (state, action) => {
  switch (action.type) {
    case 'ABOUT_DETAIL_FETCHING':
      return {...state, isFetching: true};
    case 'ABOUT_DETAIL_UPDATE':
      return {isFetching: false, data: action.data};
    default:
      return state;
  }
};

export {AboutDetailPageReducer};
